const serverlessUrl = () => 'https://editor.wix.com/_serverless/dm-anyide-site-deployment';
export const getBaseUrl = () => `${serverlessUrl()}/getBase`;
export const updateSiteUrl = () => `${serverlessUrl()}/updateSite`;
export const getUpdateSiteStatusUrl = (updateSiteTaskId) => `${serverlessUrl()}/getUpdateSiteStatus/${updateSiteTaskId}`;
